import gridSideBarConfig from '@/grid/gridSideBarConfig'
import { AgGridRowModelType, IModeView, AgGridServerSideStoreType } from '@/shared/models/ag-grid.model'
import { CrudModelBaseInfinite, initialInfiniteState } from '@/shared/resources/infinite-datasources/infinite-resource.model'
import { Nullable } from '@/shared/types/app.types'
import {
    FilterChangedEvent,
    GetContextMenuItemsParams,
    GridOptions,
    GridReadyEvent,
    MenuItemDef,
    SelectionChangedEvent,
    SortChangedEvent
} from '@ag-grid-enterprise/all-modules'
import { uniqueId } from 'lodash'
import { Component, Mixins } from 'vue-property-decorator'
import { GridExportMixin } from '@/mixins/grid-export.mixin'
import { GridColumnRequest } from '@/api/services/common.dto'
import { GridUtils } from '@/shared/util/grid-utils'

@Component
export default class BaseCrudInfiniteServerSideComponent<T> extends Mixins<GridExportMixin>(GridExportMixin) {
    state: CrudModelBaseInfinite<T>

    constructor() {
        super()
        this.state = initialInfiniteState<T>()
    }

    get gridOptions(): GridOptions {
        return {
            sideBar: gridSideBarConfig,
            getContextMenuItems: this.getContextMenuItems,
            onGridReady: this.onGridReady,
            onSelectionChanged: this.onSelectionChanged,
            onSortChanged: this.onSortChanged,
            onFilterChanged: this.onFilterChanged,
            getRowHeight: (data:any) => this.getRowHeight(data.data),
            rowModelType: AgGridRowModelType.SERVER_SIDE,
            serverSideStoreType: AgGridServerSideStoreType.PARTIAL,
            pagination: true,
            paginationPageSize: this.state.elementsByPage,
            cacheBlockSize: this.state.elementsByPage,
            paginationAutoPageSize: false
        }
    }

    get hasActive(): boolean {
        return !!this.state.selectedRows.find((item: any) => item?.active)
    }

    get hasDeactive(): boolean {
        return !!this.state.selectedRows.find((item: any) => !item?.active)
    }

    get hasAllActivated(): boolean {
        return this.state.selectedRows.length === (this.state.selectedRows.filter((item: any) => item?.active)?.length)
    }

    get hasAllDeactivated(): boolean {
        return this.state.selectedRows.length === (this.state.selectedRows.filter((item: any) => !item?.active)?.length)
    }

    get canDeactivateBatch(): boolean {
        return !!this.state.selectedRows.length && this.hasActive && !this.hasAllDeactivated
    }

    get canActivateBatch(): boolean {
        return this.hasDeactive && !this.hasAllActivated
    }

    get rowHeight(): number {
        return this.state?.viewOptions?.modeView?.size
    }

    getRowHeight(data: T): number {
        return this.rowHeight
    }

    onGridReady(event: GridReadyEvent): void {
        this.state.gridApi = event.api
        this.state.columnApi = event.columnApi

        if (this.state.columnsState) {
            this.state.columnApi?.applyColumnState({ state: this.state.columnsState, applyOrder: true })
            this.state.columnsState = null
        }
        this.state.gridApi.setServerSideDatasource(this.state.datasource)
    }

    reloadData(): void {
        this.deselectAll()
        this.state.gridApi?.setServerSideDatasource(this.state.datasource)
    }

    deselectAll(): void {
        this.state.gridApi?.deselectAll()
    }

    onSelectionChanged({ api }: SelectionChangedEvent): void {
        this.state = {
            ...this.state,
            selectedRows: api.getSelectedRows()
        }
    }

    onSortChanged({ api }: SortChangedEvent) {
        api.deselectAll()
    }

    onFilterChanged({ api }: FilterChangedEvent) {
        api.deselectAll()
    }

    showModal(title: string, selected: any, modalReference: any): void {
        this.state.actionTitle = title
        modalReference.show([selected])
    }

    changedPageSize(pageSize: number): void {
        this.state.elementsByPage = pageSize
        const api: any = this.state.gridApi
        if (api) { api.gridOptionsWrapper.setProperty('cacheBlockSize', Number(pageSize)) }
        this.state.columnsState = api?.columnModel?.getColumnState()
        this.state.updateGrid = uniqueId()
    }

    changedMode(selectedOption: IModeView): void {
        this.state = {
            ...this.state,
            viewOptions: {
                ...this.state.viewOptions,
                modeView: {
                    ...this.state.viewOptions.modeView,
                    value: selectedOption?.value,
                    icon: selectedOption?.icon,
                    size: selectedOption?.size
                }
            }
        }
        if (this.state.gridApi) {
            GridUtils.changeRowHeightGrid(this.state.gridApi, selectedOption.size)
        }
    }

    getContextMenuItems(params: GetContextMenuItemsParams): MenuItemDef[] {
        return []
    }

    getColumnsToExport(): Nullable<GridColumnRequest[]> {
        return this.$_getColumnsToExport(this.state.gridApi, this.state.columnApi)
    }
}
